const bioText = `I've had a fascination with technology since I was in middle school, and different 
elite computer friends introduced me to Doom on a series of 3.5" floppy disks, cracking and hacking, Prodigy, and Sierra 
On-Line text parsing games ("examine gem", "poke it with a stick"). I decided to make coding a full-time career in 2019. 
Since then, I have made progress towards an M.S. in Computer Science (originally earning a B.A. in Liberal Arts from 
Hendrix College in Conway, Arkansas), and completed a Web Development bootcamp. I have worked in C#/.NET, Python/Django, 
JavaScript/React, HTML/CSS, and other frameworks and libraries. I live in North Little Rock, Arkansas with my wife, 
daughter, son, and two dogs.`;

export default bioText;